import { CustomClaims, GlobalRoles } from './custom-claims.model';

/**
 * User Model
 * Represents authenticated user with custom claims
 * Based on hub authentication spec
 */

/**
 * ADN Custom Claims Structure (DEPRECATED - use CustomClaims class instead)
 * @deprecated Use CustomClaims from custom-claims.model.ts
 */
export interface AdnCustomClaims {
  userId: string;
  email: string;
  entityId?: string;
  entityName?: string;
  roles: number; // Bitwise roles
  permissions: string[]; // Array of permission strings
  accountStatus: 'active' | 'suspended' | 'pending';
  lastLogin?: string; // ISO timestamp
}

/**
 * User Model
 */
export interface User {
  uid: string;
  email: string;
  displayName?: string;
  photoURL?: string;
  emailVerified: boolean;

  // Custom Claims (compressed format from Firebase)
  customClaims?: CustomClaims;

  // Computed properties (deprecated - use customClaims methods instead)
  roles?: GlobalRoles[];
  permissions?: string[];
  phoneNumber?: string;
}

/**
 * Helper functions for role checking
 * @deprecated Use CustomClaims methods directly (e.g., user.customClaims?.hasGlobalRole())
 */
export class UserRoleHelper {
  /**
   * Check if user has specific global role
   * @deprecated Use user.customClaims?.hasGlobalRole() instead
   */
  static hasRole(user: User, role: GlobalRoles): boolean {
    if (!user.customClaims) return false;
    return user.customClaims.hasGlobalRole(role);
  }

  /**
   * Check if user has any of the specified roles
   * @deprecated Use user.customClaims?.hasAnyGlobalRole() instead
   */
  static hasAnyRole(user: User, roles: GlobalRoles[]): boolean {
    return roles.some(role => this.hasRole(user, role));
  }

  /**
   * Check if user has all specified roles
   * @deprecated Use user.customClaims?.hasAllGlobalRoles() instead
   */
  static hasAllRoles(user: User, roles: GlobalRoles[]): boolean {
    return roles.every(role => this.hasRole(user, role));
  }

  /**
   * Check if user has specific permission
   * @deprecated Permissions are not implemented in current CustomClaims structure
   */
  static hasPermission(user: User, permission: string): boolean {
    return false;
  }

  /**
   * Get all roles for user
   * @deprecated Use user.customClaims?.getGlobalRoles() instead
   */
  static getUserRoles(user: User): GlobalRoles[] {
    return user.customClaims?.getGlobalRoles() ?? [];
  }
}
